
import * as React from 'react';
import Icon from '__common/components/Icon';
import { changeMetalXRoofAttachmentType } from 'bom/components/utils/partsSelectionFunctions';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { getLegacyBomControlProps } from 'bom/components/LegacyBomCheckboxIcon';
declare type MetalXAttachmentTypeComponentState = {
  dispatch: Function,
  group: string,
  groupItemTypes: string[],
  selectedGroupItem: string,
  legacyCheckboxIcons?: boolean,
};
export default class MetalXAttachmentType extends React.Component<MetalXAttachmentTypeComponentState, {}> {
  changeAttachmentType(group: string, selectedGroupItem: string, groupItemTypes: string[]) {
    changeMetalXRoofAttachmentType(group, selectedGroupItem, groupItemTypes);
  }

  parseTypes = (groupItemTypes: string[]) => {
    return groupItemTypes.map(type => Object({ label: type, value: type, key: type.toLowerCase().split(' ').join('-') }));
  }  
  render() {
    const { group, groupItemTypes, selectedGroupItem, legacyCheckboxIcons = false } = this.props;
    const types = this.parseTypes(groupItemTypes);
    return (
      <div className="attachment-types-selector">
        <div className="control-panel-sublabel">
            {group.toUpperCase()}
        </div>
        {groupItemTypes.length > 1? 
        <RadioGroup
          name="metalx-attachment-types"
          value={selectedGroupItem}
          onChange={(event) => this.changeAttachmentType(group, event.target.value, groupItemTypes)}
          row={true}
        >
          {types.map((type) => (
            <FormControlLabel
              key={type.key}
              value={type.value}
              control={<Radio {...getLegacyBomControlProps(legacyCheckboxIcons)} />}
              label={type.label}
            />
          ))}
        </RadioGroup>
        :
        <FormControlLabel
          control={
            <Radio
              {...getLegacyBomControlProps(legacyCheckboxIcons)}
              id={`${group}-selection-control`}
              name="metalx-attachment-types"
              disabled={selectedGroupItem === groupItemTypes[0] ? true: false}
              onChange={() => this.changeAttachmentType(group, selectedGroupItem === groupItemTypes[0]? '': groupItemTypes[0], groupItemTypes)}
              checked={selectedGroupItem === groupItemTypes[0]}
            />
          }
          label={`${groupItemTypes[0]}`}
        />
        }
      </div>
    );
  }
}
